import { useEffect, useRef } from "react";

export default function WhiteSpinner() {
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const rings = containerRef.current.querySelectorAll(".ring");
    const centerDot = containerRef.current.querySelector(".center-dot");
    let startTime = null;

    if (centerDot) {
      centerDot.style.backgroundColor = "#ffffff";
      centerDot.style.boxShadow = "0 0 8px rgba(255, 255, 255, 0.8)";
    }

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;

      rings.forEach((ring, index) => {
        const delay = index * 1000; 
        const effectiveTime = (elapsed - delay) % 2500; 

        if (effectiveTime >= 0 && effectiveTime <= 2500) {
          const progress = Math.min(effectiveTime / 2500, 1);
          const scale = progress;
          const opacity = 1 - progress;

          const borderOpacity = opacity;
          const glowIntensity = 1 - progress;

          ring.style.transform = `translate(-50%, -50%) scale(${scale})`;
          ring.style.opacity = borderOpacity;
          ring.style.boxShadow = `0 0 ${
            10 * glowIntensity
          }px rgba(255, 255, 255, ${0.5 * glowIntensity})`;
        } else if (effectiveTime < 0) {
          ring.style.transform = `translate(-50%, -50%) scale(0)`;
          ring.style.opacity = 0;
          ring.style.boxShadow = "none";
        }
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    const handleVisibilityChange = () => {
      if (document.hidden) {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
          animationRef.current = null;
        }
      } else {
        startTime = null;
        if (containerRef.current && !animationRef.current) {
          animationRef.current = requestAnimationFrame(animate);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "60px",
        height: "60px",
      }}
    >
      <div
        className="center-dot"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "12px",
          height: "12px",
          backgroundColor: "#ffffff",
          borderRadius: "50%",
          zIndex: 3,
          boxShadow: "0 0 10px rgba(255, 255, 255, 0.8)",
        }}
      ></div>

      <div
        className="ring"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%) scale(0)",
          width: "60px",
          height: "60px",
          border: "4px solid #ffffff",
          borderRadius: "50%",
          opacity: 0,
          zIndex: 1,
          boxShadow: "0 0 8px rgba(255, 255, 255, 0.6)",
        }}
      ></div>

      <div
        className="ring"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%) scale(0)",
          width: "60px",
          height: "60px",
          border: "4px solid #ffffff",
          borderRadius: "50%",
          opacity: 0,
          zIndex: 1,
          boxShadow: "0 0 8px rgba(255, 255, 255, 0.6)",
        }}
      ></div>
    </div>
  );
}
